import { cn } from '@/lib/utils'
import { FxIcon } from './FxIcon'

/** Work in flight, with the word that says which work. */
export function FxSpinner({
  label,
  className,
}: {
  label?: string
  className?: string
}) {
  return (
    <div className={cn('flex items-center gap-2 text-body text-text-muted', className)}>
      <FxIcon name="progress_activity" size={20} className="animate-spin" />
      {/* The label is the accessible name; the icon carries none. */}
      <span role="status">{label ?? 'Wird geladen …'}</span>
    </div>
  )
}
